// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"a08b167a","710":"581785d3","845":"f8166e31"}[chunkId] + ".chunk.js";
};